import { forwardRef, useMemo } from 'react';

import {
  TextareaProps as MantineTextareaProps,
  Textarea as MantineTextarea
} from '@mantine/core';

import { useMergeClassNames } from '../../utils';

import { TextAreaOverrideClassnames } from './TextArea.styles';

interface TextareaProps extends MantineTextareaProps {
  borderless?: boolean;
}

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ size = 'md', borderless, ...rest }, ref) => {
    const classes = useMemo(() => {
      return TextAreaOverrideClassnames({
        size,
        borderless
      });
    }, [size, borderless]);

    const mergedClassNames = useMergeClassNames({
      classNames: [classes, rest.classNames]
    });

    return (
      <MantineTextarea
        {...rest}
        ref={ref}
        size={size}
        classNames={mergedClassNames}
      />
    );
  }
);

export { Textarea };
export type { TextareaProps };
